import { connect } from "react-redux";

import { EmergencyUploadView } from "../view/view";
import { RootState } from '../../../app/store';

interface OwnProps {
    id: string;
}

// The upload runs inside the view (it needs progress callbacks and keeps
// the file object, which does not belong in the store); the store only
// supplies who is signed in.
function mapStateToProps(state: RootState, _ownProps: OwnProps) {
    return {
        token: state.LoginManager.model.token,
        role: state.LoginManager.model.role,
    };
}

const UpdateInputContainer = connect(mapStateToProps)(EmergencyUploadView);
export default UpdateInputContainer;
